import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { onUploaded, setQueueUser, startQueue } from "../lib/queue";
import { qk } from "../lib/queries";
import { useAuth } from "../features/auth/useAuth";

/**
 * docs/ROADMAP.md B2 — connects the offline upload queue to the session.
 *
 * Two jobs, both of them small: point the queue at the logged-in student (so an
 * account switch on a shared phone can never upload the previous student's
 * takes), and refresh 今日任务 / 我的录音 whenever a queued take finally lands.
 *
 * Idempotent, so screens that mount outside `AppShell` can call it too.
 */
export function useUploadQueueBridge(): void {
  const { me } = useAuth();
  const qc = useQueryClient();
  const userId = me?.user.id ?? null;

  useEffect(() => {
    setQueueUser(userId);
  }, [userId]);

  useEffect(() => {
    startQueue();
  }, []);

  useEffect(
    () =>
      onUploaded(() => {
        void qc.invalidateQueries({ queryKey: qk.assignments });
        void qc.invalidateQueries({ queryKey: qk.recordings });
      }),
    [qc],
  );
}
